import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slices/counterSlice";
import auth from "./features/auth";
import mission from "./features/mission";
import specialtySlice from "./features/specialtySlice";
import doctor from "./features/doctor";
import info from "./features/information";
import cooperate from "./features/cooperate";
import fileImage from "./features/fileImage";
import relationship from "./features/relationship";
import appointment from "./features/appointment";
import review from "./features/review";
import deposit from "./features/deposit";
import withdraw from "./features/withdraw";
import wallet from "./features/wallet";
import question from "./features/question";
import voucher from "./features/voucher";
import check_in from "./features/check_in";
import notification from "./features/notification";
import QRcode from "./features/QRcode";
import banner from "./features/banner";

export const store = configureStore({
  reducer: {
    question,
    mission,
    wallet,
    withdraw,
    review,
    deposit,
    appointment,
    relationship,
    fileImage,
    auth,
    specialtySlice,
    cooperate,
    doctor,
    info,
    voucher,
    check_in,
    notification,
    QRcode,
    banner,
    counter: counterReducer,
  },
});
